/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Statsasof2Inputs */

const en_statsasof2 = /** @type {(inputs: Statsasof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`As of ${i?.time}`)
};

const de_statsasof2 = /** @type {(inputs: Statsasof2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stand: ${i?.time}`)
};

/**
* | output |
* | --- |
* | "As of {time}" |
*
* @param {Statsasof2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsasof2 = /** @type {((inputs: Statsasof2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsasof2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsasof2(inputs)
	return de_statsasof2(inputs)
});
export { statsasof2 as "statsAsOf" }